<template>
  <pre ref="pre"><code class="chat-text language-markdown" v-html="msgFormatted"></code></pre>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { marked } from 'marked'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'

@Options({
  props: {
    msg: String
  }
})
export default class Code extends Vue {
  msg!: string
  msgFormatted: string = ''

  async mounted() {
    await this.updateMessages()
  }

  async updated() {
    await this.updateMessages()
  }

  async updateMessages() {
    this.msgFormatted = await this.formatMarkdown(this.msg ?? '')
    // Prism.highlightAll()
  }

  async formatMarkdown(text: string): Promise<string> {
    return marked.parse(text)
  }
}
</script>
<style scoped lang="scss">
  pre code[class*="language-" ] > ol,
  code[class*="language-"] > ul,
  code[class*="language-"] > ol {
    padding-left: 40px !important;
  }

  code[class*="language-"] > hr:first-child {
    display: none !important;
    opacity: 0;
  }

  pre[class*="language-" ],
  code[class*="language-"] {
    background: #02131f;
    box-sizing: border-box;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 18px;
    overflow: auto;
    white-space: normal;
    word-break: break-word;

    ol {
      margin-left: 40px;
    }
    ul {
      margin-left: 40px;
    }
    dl {
      margin-left: 40px;
    }

    p + ol,
    p + ul {
      padding-left: 40px;
    }

    ol {
      padding-left: 40px;
    }

    &:deep(ul, ol, dl) {
      padding-left: 40px;
    }
  }
</style>